import Model from './Model'

export default class OrderModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'orders'
  }
}
